module.exports = __webpack_public_path__ + "IGDC2023-2badab00.webp";